import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toastConfig } from 'lib/reactToastify/config';
import { toast } from 'react-toastify';

import { queryKeys } from 'api/config';
import { logError } from 'lib/sentry/logError';
import { useMutationHTTPRequest } from 'shared_DEPRECATED/hooks';
import { dateUtils } from 'shared_DEPRECATED/utils';

import { GoalCardType } from 'features/goal/types';
import { useUserId } from 'features/user/hooks/useUserId';

import { Goal__DEPRECATED } from '../../Goal__DEPRECATED';

export const useGoalDetailsPrioritizeMutation = () => {
  const { request } = useMutationHTTPRequest();
  const queryClient = useQueryClient();
  const userId = useUserId();

  return useMutation(
    ({
      goalId,
      isPrioritized,
    }: {
      goalId: GoalCardType['goalId'];
      isPrioritized: boolean;
    }) => {
      return request({
        url: `/api/goals/${goalId}/prioritize`,
        body: {
          prioritized: !isPrioritized,
        },
      });
    },
    {
      onMutate: async ({ goalId }) => {
        await queryClient.cancelQueries([queryKeys.goal, goalId]);

        const previousValue = queryClient.getQueryData<Goal__DEPRECATED>([
          queryKeys.goal,
          goalId,
        ]);

        queryClient.setQueryData<Goal__DEPRECATED>(
          [queryKeys.goal, goalId],
          (oldGoal) => {
            return {
              ...oldGoal!,
              prioritizedAt: oldGoal!.prioritizedAt
                ? null
                : dateUtils.utc().toISOString(),
            };
          }
        );

        return { previousValue };
      },
      onSuccess: (_, { isPrioritized }) => {
        toast.success(
          isPrioritized
            ? 'Unset as prioritized goal'
            : 'Set as prioritized goal',
          {
            icon: false,
            ...toastConfig,
          }
        );
      },
      onSettled: () => {
        queryClient.invalidateQueries([queryKeys.challengeGoals, userId]);
      },
      onError: (err, { goalId }, context) => {
        logError(err);
        queryClient.setQueryData<Goal__DEPRECATED | undefined>(
          [queryKeys.goal, goalId],
          context?.previousValue
        );
      },
    }
  );
};
